import React from 'react';
import { RiPauseLine } from 'react-icons/ri';
import { v4 as uuidv4 } from 'uuid';

import Mode from './Mode';

import { MODE } from '@/define/robotStatus';

const Panel = ({ data: robots }) => {
  return (
    <Mode
      data={robots}
      modeId={MODE.ARDUPILOT.COPTER.BRAKE.id}
      desc="Emergency brake to stop all movement immediately"
    />
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Brake';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiPauseLine;
Command.Panel = Panel;

export default Command;
